import React from "react";

const PopUpScreenTitle = ({
  title,
  hederDetails,
  setpopUpOpen,
  viewDetails,
  deleteDetails,
  blockDetails,
  unBlockDetails,
  uploadDetails,
  userDeactivateDetails,
  userActivateDetails,
  flag,
}) => {
  // 🔹 Centralized title logic
  const getTitle = () => {
    if (deleteDetails) return `${title} - Delete`;
    if (blockDetails) return `${title} - Make Inactive`;
    if (unBlockDetails) return `${title} - Make Active`;
    if (uploadDetails) return `${title} - Upload Invoices`;
    if (userDeactivateDetails) return `${title} - Deactivate Login`;
    if (userActivateDetails) return `${title} - Activate Login`;
    if (viewDetails) return `${title} - View`;

    if (flag === 1) return `${title} - View`;
    if (flag === 2) return `${title} - Edit`;
    if (flag === 3) return `${title} - Delete`;

    return title;
  };

  return (
    <div className="p-2">
      <button className="w-full flex justify-between items-center rounded bg-[#3D6643] px-2 py-2">
        <span className="text-xl font-medium text-white">
          {/* {hederDetails && getTitle()} */}
           {hederDetails && (
            <>
              {flag === 1
                ? `${title} - View`
                : flag === 2
                ? `${title} - Edit`
                : flag === 3
                ? `${title} - Delete`
                : title}
            </>
          )}
          {viewDetails && `${title} - View`}
          {deleteDetails && `${title} - Delete`}
          {blockDetails && `${title} - Make Inactive`}
          {unBlockDetails && `${title} - Make Active`}
          {uploadDetails && `${title} - Upload Invoices`}
          {userDeactivateDetails && `${title} - Deactivate Login`}
          {userActivateDetails && `${title} - Activate Login`}
        </span>

        <span
          className="text-2xl text-white cursor-pointer"
          onClick={() => setpopUpOpen(false)}
        >
          &times;
        </span>
      </button>
    </div>
  );
};

export default PopUpScreenTitle;
